import React from 'react';
import Script from 'react-load-script'

const handleScriptLoad = () => {
    window.iFrameResize();
}

export default () => (
    <Script
        url="https://www.financialcalculators.net/iframe-resizer/iframeResizer.min.js"
        onLoad={handleScriptLoad.bind(this)}
    />
);